import { jsx as _jsx } from "react/jsx-runtime";
import { StreamrAppService } from '../../services/streamrapp/StreamrAppService';
import { Canvas } from '../Canvas';
import { DirectVideo } from './DirectVideo';
/**
 * The display scene as the video worker shows it: a `<video>` fed by the
 * worker while one video is shown directly, the display canvas otherwise.
 * The canvas remounts when the worker asks for a fresh one (a lost WebGPU
 * device) and whenever the output comes back from the direct video; the
 * worker keeps its renderer and clocks across both.
 */
export function DisplayOutput({ onCanvasMount, onCanvasClick, fill, className, }) {
    const output = StreamrAppService.getOutput();
    const track = output.useDirectVideoTrack();
    const canvasGeneration = output.useCanvasGeneration();
    if (track) {
        return (_jsx(DirectVideo, { track: track, onVideoClick: onCanvasClick, className: className }));
    }
    return (_jsx(Canvas, { onCanvasMount: onCanvasMount, onCanvasClick: onCanvasClick, fill: fill, className: className }, canvasGeneration));
}
